import { Spacer } from '@zapier/design-system';
import { clsx } from 'clsx';
import React from 'react';
import styles from './PageHeaderBase.module.scss';

export type PageHeaderBaseProps = {
  /** Optional top row (usually breadcrumbs) to display at the top of the header
   * If not provided, the header will have a spacer to preserve space for the top row.
   * This maintains consistency of the page layout for customers when navigating
   * between different services.
   */
  topRowContent?: React.ReactNode;
  /** Optional className for custom styling */
  className?: string;
  /** The main content of the page header */
  children?: React.ReactNode;
};

/**
 * A consistent page header layout component that includes support for a basic PageHeader layout:
 * - Breadcrumbs navigation
 * - Main content area: rows are evenly spaced.
 * Use this component when you want to customize the header content, but keep the overall layout.
 */
export const PageHeaderBase = ({
  topRowContent,
  children,
  className,
}: PageHeaderBaseProps) => {
  return (
    <div className={clsx(styles.header, className)} data-zds>
      {topRowContent ? (
        <div className={styles.toprow} data-zds>
          {topRowContent}
        </div>
      ) : (
        <Spacer height="var(--zds-space-20)" />
      )}
      {children}
    </div>
  );
};
